// @flow
import { configureStore } from '@reduxjs/toolkit'
import packetReducer from 'pages/Slices/packetSlice'

const store: typeof configureStore = configureStore({
  reducer: {
    packet: packetReducer,
  },
})

export default store
